import Tile from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import { TileArcGISRest, XYZ } from "ol/source";
import TileState from "ol/TileState";

// XHR + blob-URL tile loader for endpoints that require a Bearer token.
// XYZ sources can't set headers directly on tile requests; this is the workaround.
function authTileLoad(azureLoginControl) {
  return function (tile, src) {
    const xhr = new XMLHttpRequest();
    xhr.responseType = "blob";
    xhr.addEventListener("loadend", function () {
      const data = this.response;
      if (data !== undefined) {
        tile.getImage().src = URL.createObjectURL(data);
      } else {
        tile.setState(TileState.ERROR);
      }
    });
    xhr.addEventListener("error", function () {
      tile.setState(TileState.ERROR);
    });
    xhr.open("GET", src);
    xhr.setRequestHeader(
      "Authorization",
      "Bearer " + azureLoginControl.get("idToken"),
    );
    xhr.send();
  };
}

/**
 * The five basemap tile layers shared by the WKT viewer and CaJ editor:
 * OSM (no auth), Hillshade (ArcGIS, no auth), Satellite (Google, no auth),
 * Genesis (TomTom, Bearer), Orbis (TomTom, Bearer). Returned as
 * `[{ name, layer }, ...]` so each app can build its own UI (layerswitcher
 * vs. custom radio panel).
 */
export function createBasemapTileLayers(azureLoginControl) {
  const authLoader = authTileLoad(azureLoginControl);
  // Order matters — the WKT viewer's ol-layerswitcher renders radios in this
  // array order. Preserve [Hillshade, Satellite, Genesis, OSM, Orbis] to
  // match the layout the main viewer has shipped for a long time.
  return [
    {
      name: "Hillshade",
      layer: new Tile({
        source: new TileArcGISRest({
          url: "https://services.arcgisonline.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer",
        }),
      }),
    },
    {
      name: "Satellite",
      layer: new Tile({
        source: new XYZ({
          url: "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
        }),
      }),
    },
    {
      name: "Genesis",
      layer: new Tile({
        source: new XYZ({
          tileLoadFunction: authLoader,
          url:
            process.env.GENESIS_MAP_URL +
            "/map/1/tile/basic/main/{z}/{x}/{y}.png",
        }),
      }),
    },
    { name: "OSM", layer: new Tile({ source: new OSM() }) },
    {
      name: "Orbis",
      layer: new Tile({
        source: new XYZ({
          tileLoadFunction: authLoader,
          url:
            process.env.GENESIS_MAP_URL +
            "/maps/orbis/map-display/tile/{z}/{x}/{y}.png?apiVersion=1&tileSize=512",
        }),
      }),
    },
  ];
}
